import {Component, Vue} from "vue-property-decorator";
import {UserRoleEnum} from "@/enums/userRolesEnum";
import {HTTP} from "@/utils/httpCommonUtil";
import marked from 'marked';

@Component({
  components: {},
})
export default class ReleaseNotes extends Vue {
  private readonly nmrFilename = 'nmr-release-notes.md';
  private readonly providerFilename = 'provider-release-notes.md';
  private readonly facilityFilename = 'facility-release-notes.md';
  private cardExpanded = true;

  private nmrNotesMarkDown = '';
  private providerNotesMarkDown = '';
  private facilityNotesMarkDown = '';

  async created() {
    await this.loadReleaseNotes();
  }

  get nmrNotes(): string {
    return marked(this.nmrNotesMarkDown);
  }

  get providerNotes(): string {
    return marked(this.providerNotesMarkDown);
  }

  get facilityNotes(): string {
    return marked(this.facilityNotesMarkDown);
  }

  get isNmr(): boolean{
    return !this.isProvider && !this.isFacility;
  }

  get isProvider(): boolean {
    return this.$store.getters['user/isProvider'];
  }

  get isFacility(): boolean {
    return this.$store.getters['user/isFacilityContact'];
  }

  get isAdmin(){
    return this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  }

  async loadReleaseNotes() {
    if (!this.isProvider && !this.isFacility) {
      this.nmrNotesMarkDown = await this.openDocument(`release-notes/${this.nmrFilename}`);
    }
    if (this.isNmr || this.isProvider) {
      this.providerNotesMarkDown = await this.openDocument(`release-notes/${this.providerFilename}`);
    }
    if (this.isNmr || this.isFacility) {
      this.facilityNotesMarkDown = await this.openDocument(`release-notes/${this.facilityFilename}`);
    }
  }

  async openDocument(s3Key: string) {
    try {
      const response = await HTTP.get(this.getUrl() + `?s3key=${s3Key}`);
      if (!response.data || !response.data.data) {
        throw new Error("Error finding release notes.");
      }

      let file = await HTTP.get(response.data.data);
      if (!file || !file.data) {
        throw new Error("Error getting release notes.");
      }
      return file.data;
    } catch (err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred retrieving release notes.'
      });
    }
  }

  getUrl(): string {
    const url = '/api/s3/signed-url/get';
    if (this.isProvider) {
      return url + '-provider';
    } else if (this.isFacility) {
      return url + '-facility';
    }
    return url;
  }

  expandClicked() {
    this.cardExpanded = !this.cardExpanded;
  }
}



// WEBPACK FOOTER //
// ./src/components/about/releaseNotes/ReleaseNotes.ts